exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._9_FB0vP9b0ZvBYDOmwd4H{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-style:italic;padding:.71429rem 0 1.42857rem}._36XmYVqGE58sjdlGEnF3bl{margin-right:.35714rem}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"RejectNote_content_info": "_9_FB0vP9b0ZvBYDOmwd4H",
	"RejectNote_content_info_icon": "_36XmYVqGE58sjdlGEnF3bl"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./components/RejectNote/style.postcss
// module id = 1504
// module chunks = 0